import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Link, Redirect } from 'react-router-dom';
import { Button } from 'antd';
import { NavLink } from 'react-router-dom';
import { clearAuthState } from '../../redux/reducers/auth/auth.actions';
// import FaIcon from '../global/fa-icon/fa-icon';
// import api from '../../api';
// import _ from 'lodash';


class Logout extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    // onAuthChange: PropTypes.func,
  };

  static defaultProps = {
    // onAuthChange: _.noop,
  };

  componentDidMount() {
    this.props.clearAuthState(null, null);
  }


  render() {
    return (
      <div className="logout">
        <div className="login-prompt modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header no-border">
              <h5 className="modal-title">You have been signed out!</h5>
            </div>
            <div className="modal-body center">
              <NavLink to="/login">
                <Button type="primary" size="large">Sign in</Button>
              </NavLink>
            </div>
            <div className="modal-footer">
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    // auth: state.auth,
  };
}


const mapDispatchToProps = {
  clearAuthState,
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
